













































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { SumupGroup, SumupUnitResult, AssessmentResult, BunpuResult, SumupUnitAll, ColKindEnum, PracticeFileUpload } from "../../modules/practice_examinee/ResultTop"

export interface Data {
  sumupGroup: SumupGroup
  sumupUnitResults: SumupUnitResult[]
  assessmentResults: AssessmentResult[]
  assessmentNames: string[]
  scoreTypes: number[]
  assessmentHeaders: string[]
  assessmentRows: any[]
  bunpuTotalResults: BunpuResult[]
  bunpuCurriculumResults: BunpuResult[]
  total_unit_names: string[]
  curriculum_unit_names: string[]
  sumupUnitAlls: SumupUnitAll[]
  errors: string[]
  ColKindEnum: Readonly<{ScoreRange: number; Count: number; ScoreRate: number}>
  isExistsResultImage: boolean
  is_exists_gender_result: boolean
  section: any
  column: any
  asset: any
  resultColCount: number
  pracitceFileUploads: PracticeFileUpload[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sumupGroup: null,
      sumupUnitResults: [],
      assessmentResults: [],
      assessmentNames: [],
      scoreTypes: [],
      assessmentHeaders: [],
      assessmentRows: [],
      bunpuTotalResults: [],
      bunpuCurriculumResults: [],
      total_unit_names: [],
      curriculum_unit_names: [],
      sumupUnitAlls: [],
      errors: [],
      ColKindEnum: ColKindEnum,
      isExistsResultImage: false,
      is_exists_gender_result: false,
      section: {},
      column: {},
      asset: {},
      resultColCount: 0,
      pracitceFileUploads: []
    });

    /************************************************************
     * 教科詳細画面へ遷移
     ************************************************************/

    const toResultDetail = (sumup_unit_id: number) => {
      if(context.root.$store.state.currentUser.role == Common.RoleEnum.PracticeExaminee){
        context.root.$router.push(`/candidate/result_detail/${sumup_unit_id}`).catch(err => {});
      }else{
        context.root.$router.push(`/teacher_site/practice_examinee_result_detail/${sumup_unit_id}`).catch(err => {});
      }
    }

    /************************************************************
     * 答案画像ダウンロード
     ************************************************************/

    const downloadTouanZip = async () => {
      if(!window.confirm("答案をダウンロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.get(`/api/practice_examinee/result_top/download_touan_zip/${context.root.$store.state.practice_examinee_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/zip' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${state.sumupGroup.name} 答案.zip`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 模範解答ダウンロード
     ************************************************************/

    const downloadCorrectZip = async () => {
      if(!window.confirm("模範解答をダウンロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.get(`/api/practice_examinee/result_top/download_correct_zip/${context.root.$store.state.practice_examinee_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/zip' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${state.sumupGroup.name} 模範解答.zip`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 配布資料ダウンロード
     ************************************************************/
    
    const downloadPdf = async (practiceFileUpload: PracticeFileUpload) => {
      if(!window.confirm(`${practiceFileUpload.title}をダウンロードします。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.get(`/api/practice_examinee/result_top/download_pdf/${context.root.$store.state.practice_examinee_id}/${practiceFileUpload.id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${practiceFileUpload.title}.pdf`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }
    
    /************************************************************
     * 初期表示データ取得
     ************************************************************/

    const initialize = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      context.root.$store.commit("setIsHeaderDisp", true);

      await http.get(`/api/practice_examinee/result_top?practice_examinee_id=${context.root.$store.state.practice_examinee_id}`).then(response => {
        state.sumupGroup = response.data.sumup_group;
        state.sumupUnitResults = response.data.sumup_unit_results.map((x: any) => new SumupUnitResult(x));
        state.assessmentResults = response.data.assessment_results.map((x: any) => new AssessmentResult(x));
        state.is_exists_gender_result = response.data.is_exists_gender_result;
        state.scoreTypes = response.data.score_types;
        state.section = response.data.section;
        state.column = response.data.column;
        state.asset = response.data.asset;
        state.resultColCount = response.data.result_col_count;
        state.pracitceFileUploads = response.data.practice_file_uploads;
        
        state.assessmentResults.forEach((x, i) => {
          let cols = [];
          cols.push(x.name);
          x.assessment_score_results.forEach((y, j) => {
            
            if(state.scoreTypes[j] == 1){
              cols.push(`${y.score_to}点<br>～<br>${y.score_from}点`);
              cols.push(y.is_exists_assessment_examinee ? "<span style='color:#1e90bd;'>★</span>" : "");
            }else{
              if(i == 0){
                cols.push(`${y.score_from}以上`);
              }else{
                cols.push(`${y.score_to}<br>～<br>${y.score_from}`);
              }
              cols.push(y.is_exists_assessment_examinee ? "<span style='color:#1e90bd;'>★</span>" : "");
            }
          });
          state.assessmentRows.push(cols);
        });
        
        state.assessmentNames = response.data.assessment_names;
        state.assessmentNames.forEach((x, i) => {
          const scoreName = state.scoreTypes[i] == 1 ? "基準点" : "基準偏差値";
          state.assessmentHeaders.push(scoreName);
          state.assessmentHeaders.push("判定");
        })
        
        state.sumupUnitAlls = response.data.sumup_unit_alls.map((x: any) => new SumupUnitAll(x));
        state.bunpuTotalResults = response.data.bunpu_total_results.map((x: any) => new BunpuResult(x, state.sumupUnitResults));
        state.bunpuCurriculumResults = response.data.bunpu_curriculum_results.map((x: any) => new BunpuResult(x, state.sumupUnitResults));
        state.total_unit_names = state.sumupUnitAlls.filter(x => [Common.SumupUnitTypeEnum.MultiCurriculum, Common.SumupUnitTypeEnum.MultiUnit, Common.SumupUnitTypeEnum.Course].includes(x.unit_type) && x.result_published).map(x => x.name);
        state.curriculum_unit_names = state.sumupUnitAlls.filter(x => x.unit_type == Common.SumupUnitTypeEnum.SingleCurriculum && x.result_published).map(x => x.name);

        state.isExistsResultImage = response.data.is_exists_result_image;
      }).catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。`);
        }
        window.history.back();
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * Mounted
     ************************************************************/

    onMounted(async () => {
      initialize();
    });

    return {
      ...toRefs(state),
      downloadTouanZip,
      downloadCorrectZip,
      toResultDetail,
      downloadPdf,
    };
  }
})
